import {
  Alert,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../Components/Dashboard/DashboardLayout/DashboardLayout';
import Footer from '../../Components/Footer/Footer';
import { useFacility } from '../../context/FacilityContext';
import {
  deleteImagesFunction,
  getImageURL,
  listAssignedResidentsFunction,
  loadCalendarImage,
  loadImagesFunction,
} from '../../firebase/functions';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db, storage } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import CalendarTemplate from './CalendarComponents/CalendarTemplate';
import CalendarFrame from './CalendarComponents/CalendarFrame';
import CalendarImages from './CalendarComponents/CalendarImages';
import SignagePreview from './CalendarComponents/SignagePreview';
import { getNewYorkTimeZoneDate } from '../../utils/dayjsUs';
export const allMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
function CalenbdarEditor() {
  const navgate = useNavigate();
  const { claims, currentUser } = useAuth();
  const { facilityId } = useFacility();
  const [calendarTemplateImages, setCalendarTemplateImages] = useState([]);
  const [calendarFrameImages, setCalendarFrameImages] = useState([]);
  const [calendarImages, setCalendarImages] = useState([]);
  const [errorAlert, setErrorAlert] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [choosenMonth, setChosenMonth] = useState(
    getNewYorkTimeZoneDate().format('MMMM'),
  );
  const [facilityData, setFacilityData] = useState({});

  const getCalendarImages = async () => {
    setIsLoading(true);
    loadCalendarImage({ facilityId, month: choosenMonth })
      .then((result) => {
        const imagesData = result.data.images;

        setCalendarTemplateImages(
          imagesData.filter(
            (image) =>
              image.type === 'calendarTemplate' && image.month === choosenMonth,
          ),
        );
        setCalendarFrameImages(
          imagesData.filter(
            (image) =>
              image.type === 'calendarFrame' && image.month === choosenMonth,
          ),
        );
        // not have type
        setCalendarImages(imagesData.filter((image) => !image.type));
      })
      .catch((error) => {
        setErrorAlert(error?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const getFacilityData = async () => {
    setIsLoading(true);

    try {
      const querySnapshot = await getDocs(
        query(
          collection(db, 'facilities'),
          where('facilityId', '==', facilityId),
          where('month', '==', choosenMonth),
        ),
      );
      if (!querySnapshot.empty) {
        const data = querySnapshot.docs[0].data();

        setFacilityData({
          ...data,
        });
      } else {
        setFacilityData({});
      }
    } catch (error) {
      console.error('Error getting facility data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (facilityId) {
      getCalendarImages(); // Fetch calendar images whenever facilityId is available
      getFacilityData();
    }
  }, [facilityId, choosenMonth]);
  return (
    <div>
      <DashboardLayout facilityId={facilityId} isLoading={isLoading}>
        <div>
          {errorAlert && (
            <Alert
              severity="error"
              onClose={() => {
                setErrorAlert('');
              }}
            >
              {errorAlert}
            </Alert>
          )}
        </div>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          <FormControl sx={{ minWidth: '200px' }}>
            <InputLabel id="selectLabel" shrink={true}>
              Filter Overlays
            </InputLabel>
            <Select
              value={choosenMonth}
              onChange={(e) => setChosenMonth(e.target.value)}
              displayEmpty
              inputProps={{ 'aria-label': 'Resident selector' }}
              sx={{ height: '46px', width: '250px' }}
              labelId="selectLabel"
              label=" Filter Overlays"
            >
              {allMonths.map((month, index) => (
                <MenuItem key={index} value={month}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={() => navgate('/calendar')}
            sx={{
              borderRadius: 2,
              fontSize: 20,
              textTransform: 'none',
              marginLeft: 'auto',
            }}
          >
            Back to Calendar
          </Button>
        </Box>
        <Box
          sx={{
            mt: '5px',
            borderTop: '4px solid black',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              borderRight: '4px solid black',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'start',
              gap: '12px',
            }}
          >
            <CalendarTemplate
              facilityId={facilityId}
              claims={claims}
              calendarTemplateImages={calendarTemplateImages}
              userUid={currentUser?.uid}
              setCalendarTemplateImages={setCalendarTemplateImages}
              setIsLoading={setIsLoading}
              getCalendarImages={getCalendarImages}
              facilityData={facilityData}
              setFacilityData={setFacilityData}
              month={choosenMonth}
            />

            <CalendarFrame
              facilityId={facilityId}
              claims={claims}
              calendarFrameImages={calendarFrameImages}
              userUid={currentUser?.uid}
              setCalendarFrameImages={setCalendarFrameImages}
              setIsLoading={setIsLoading}
              getCalendarImages={getCalendarImages}
              facilityData={facilityData}
              setFacilityData={setFacilityData}
              month={choosenMonth}
            />
            <CalendarImages
              facilityId={facilityId}
              calendarImages={calendarImages}
              setCalendarImages={setCalendarImages}
              setIsLoading={setIsLoading}
              getCalendarImages={getCalendarImages}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <SignagePreview facilityId={facilityId} />
          </Box>
        </Box>
      </DashboardLayout>
      <Footer />
    </div>
  );
}

CalenbdarEditor.propTypes = {
  facilityId: PropTypes.string,
};

export default CalenbdarEditor;
